export default __webpack_public_path__ + "static/ESCAPETHEROOMers_logo_dark-bc364b047157ad3c473d7f8312d54f3c.png";